module.exports = __webpack_public_path__ + "static/media/cd.b190b22b.svg";